import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyListComponent } from './company-list.component';
import { CompanyListRoutingModule } from './company-list.routing';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { InlineSVGModule } from 'ng-inline-svg';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared/shared.module';
import { GeneralStatisticsComponent } from './general-statistics/general-statistics.component';

@NgModule({
  declarations: [CompanyListComponent, GeneralStatisticsComponent],
  imports: [
    CommonModule,
    CompanyListRoutingModule,
    MatSelectModule,
    SharedModule,
    MatPaginatorModule,
    InlineSVGModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
  ],
})
export class CompanyListModule {}
